

























import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import { log } from '@/log'
import { ApiContent } from '@/models/api/content'
import { PointList } from '@/models/point/list/point'
import { PointListRepository } from '@/models/point/list/point-list-repository'
import FreeAreaService from '@/services/free-area/free-area'
import { PointFreeAreaService } from '@/services/free-area/point/point-free-area'
import BackToMyPageTopButton from '@spa/components/organisms/mypage/BackToMypPageTopButton.vue'
import PointLoadError from '@spa/components/pages/mypage/point/list/PointLoadError.vue'
import PointPresenter from '@spa/components/pages/mypage/point/list/PointPresenter.vue'
import { HlAppModeMixin } from '@spa/mixins/hl-app-mode'
import LoadingMixin from '@spa/mixins/loading'
import Vue, { VueConstructor } from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: { SwitchByUa, BackToMyPageTopButton },
})
export default class Point extends Mixins<LoadingMixin & HlAppModeMixin>(LoadingMixin, HlAppModeMixin) {
  @Prop({ required: true })
  listRepository: PointListRepository

  @Prop({ default: () => FreeAreaService.createForHost(PointFreeAreaService) })
  pointFreeArea: PointFreeAreaService

  points: PointList = PointList.empty

  view: VueConstructor = Vue.extend({
    template: `<div class="loading"></div>`,
  })

  headerFreeArea: ApiContent = ApiContent.empty
  footerFreeArea: ApiContent = ApiContent.empty

  private loading: boolean = true
  get isLoading(): boolean {
    // mixin用のhook
    return this.loading
  }

  async created() {
    this.loading = true

    const handleError = (error: Error) => {
      log.error({ error })

      throw error
    }

    const initialize = Promise.all([
      this.loadFreeArea().catch(handleError),
      this.listRepository.list().then(
        result => result.map(
          (points) => {
            this.points = points
          }
        ).mapLeft(
          (error) => { throw error }
        )
      ).catch(handleError),
    ])

    try {
      await initialize

      this.view = PointPresenter
    } catch {
      this.view = PointLoadError
    } finally {
      this.loading = false
    }
  }

  get totalPoint(): number {
    return this.points.total
  }

  async loadFreeArea(): Promise<void> {
    if (this.hlAppMode.isPageForHlApp) {
      return Promise.resolve()
    }

    const contents = await this.pointFreeArea.fetch()
    const [header, footer] = contents.map(c => c || ApiContent.empty)

    this.headerFreeArea = header || ApiContent.empty
    this.footerFreeArea = footer || ApiContent.empty
  }
}
